


import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApprovalLevelDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-approval-level',
  templateUrl: './approval-level.component.html',
  styleUrls: ['./approval-level.component.scss']
})
export class ApprovalLevelComponent implements OnInit {


  
  approvallevelForm: FormGroup;
  approvallevelFormArray: FormGroup;
  control = new FormControl();
  @Input() approvallevels: ApprovalLevelDto[];
  @Input() routeAnimationsElements: any;
  @Output() approvallevel = new EventEmitter<ApprovalLevelDto[]>()
  @Output() deleteApprovalLevelEvent = new EventEmitter<any>()

    selectedApprovalLevel: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     private matSnackBar: MatSnackBar
     ) {}
  ngOnInit(): void {
  }

    ngOnChanges() {
      this.createApprovalLevelForm();
    }

    createApprovalLevelForm() {
      this.approvallevelForm = this.fb.group({
        LevelName: ['', Validators.required],
        LevelPriority: [0, Validators.required],
        id: null
        });
        this.approvallevelFormArray = this.fb.group({ ApprovalLevels: this.fb.array([])
          });
        this.setApprovalLevel();
    }

  // method to display approvallevels
  setApprovalLevel() {
    const control  = this.approvallevelFormArray.controls.ApprovalLevels as FormArray;
    this.approvallevels.forEach( e => {
      control.push(
        this.fb.group(e)
      );
    });
  }


  // method to add ApprovalLevel
  addApprovalLevel(value: ApprovalLevelDto) {
    const control  = this.approvallevelFormArray.controls.ApprovalLevels as FormArray;
    control.insert(0,
          this.fb.group(value)
       );
  }

  selectApprovalLevel(value) {}

  // method to delete approvallevel from arrary list
  deleteApprovalLevel(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.approvallevelFormArray.controls.ApprovalLevels as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.approvallevels.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.approvallevels[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: ApprovalLevelDto) {
    if(this.approvallevelForm.invalid || formValue.LevelPriority === 0) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.approvallevelFormArray.get('ApprovalLevels')['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      this.addApprovalLevel(formValue);
    }
    this.selectedIndex = null;
    this.approvallevelForm.reset()
  }

  onEdit(index, value: ApprovalLevelDto) {
    this.selectedIndex = index;
    this.approvallevelForm.patchValue(value);
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.approvallevelForm.reset();
  }

  onSubmit(formValue: ApprovalLevelDto[]) {
  this.approvallevel.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteApprovalLevelEvent.emit(this.filteredDelete);
  }
  }

  checkForExistingPriority(value) {
    let LevelPriority = value.LevelPriority;
 this.approvallevelFormArray.controls.ApprovalLevels.value.map(a => {
  
   if(a.LevelPriority === LevelPriority && a.id !== value.id) {
      LevelPriority += 1;
      this.approvallevelForm.patchValue({LevelPriority: LevelPriority});
   }
 });
  }

  checkForExistingLevel(value) {
 this.approvallevelFormArray.controls.ApprovalLevels.value.map(a => {
   
   if(a.LevelName === value.LevelName) {
      this.approvallevelForm.patchValue({LevelName: ''});
      this.matSnackBar.open(`Level ${value.LevelName} Already exits! `, 'Exit', {duration: 3000});
   }
 });
  }

}
